exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proof-team-comment-add[data-v-562c3226]{position:relative;background-color:#fff;z-index:2;box-shadow:0 .75rem 1.5rem rgba(18,38,63,.03)}#proof-team-comment-add.static[data-v-562c3226]{position:static}.gold[data-v-562c3226]{color:#bf9000}", ""]);

// exports
